/* Mom's Home: Cleaning Kit card video (Round 30, 2-Nov-26).
   - Video sources + poster are only attached when the card is actually shown (drawer open / card on screen on the cart page).
   - Plays only while the cart drawer is open or the cart-page card is visible; pauses otherwise and when the tab is hidden.
   - prefers-reduced-motion or Save-Data: poster only, no video download.
   - Survives drawer / cart-page re-renders (MutationObserver). */
(function () {
  if (window.mhkVideoLoaded) return;
  window.mhkVideoLoaded = true;
  var rm = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var sd = !!(navigator.connection && navigator.connection.saveData);
  var still = function () { return rm.matches || sd; };

  function arm(v) {
    if (!v.dataset.armed) {
      v.dataset.armed = '1';
      if (v.dataset.poster) v.setAttribute('poster', v.dataset.poster);
      if (still()) return false;
      v.querySelectorAll('source[data-src]').forEach(function (s) { s.src = s.dataset.src; });
      v.addEventListener('playing', function () { v.classList.add('is-playing'); });
      v.load();
    }
    return !still();
  }
  function play(v) {
    if (!arm(v)) return;
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  function pause(v) { if (v.dataset.armed && !v.paused) v.pause(); }

  function drawerOpen() {
    var d = document.querySelector('cart-drawer');
    return !!(d && d.classList.contains('active')) && !document.hidden;
  }
  function syncDrawer() {
    var open = drawerOpen();
    document.querySelectorAll('#CartDrawer video[data-mhk-video]').forEach(function (v) { open ? play(v) : pause(v); });
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { (e.isIntersecting && !document.hidden) ? play(e.target) : pause(e.target); });
  }, { threshold: 0.25 }) : null;
  function scanPage() {
    document.querySelectorAll('.mhk-b--page video[data-mhk-video]:not([data-io])').forEach(function (v) {
      v.setAttribute('data-io', '1');
      io ? io.observe(v) : play(v);
    });
  }

  function init() {
    var d = document.querySelector('cart-drawer');
    if (d) {
      new MutationObserver(syncDrawer).observe(d, { attributes: true, attributeFilter: ['class'] });
      var inner = document.getElementById('CartDrawer') || d;
      new MutationObserver(function () { syncDrawer(); }).observe(inner, { childList: true, subtree: true });
    }
    var page = document.getElementById('main-cart-items');
    if (page) new MutationObserver(scanPage).observe(page, { childList: true, subtree: true });
    scanPage();
    syncDrawer();
    document.addEventListener('visibilitychange', function () {
      syncDrawer();
      if (document.hidden) document.querySelectorAll('.mhk-b--page video[data-mhk-video]').forEach(pause);
    });
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
